import { render, staticRenderFns } from "./Contact.vue?vue&type=template&id=36290e61&scoped=true"
import script from "./Contact.vue?vue&type=script&lang=ts"
export * from "./Contact.vue?vue&type=script&lang=ts"
import style0 from "./Contact.vue?vue&type=style&index=0&id=36290e61&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36290e61",
  null
  
)

export default component.exports